import router, { notFoundRoute } from './router'
import store from '/@/store'
import { ELocalStorageKey, EUserType } from '/@/types'
import { RouteRecordRaw } from 'vue-router'
import { loginByToken } from '/@/api/manage'
import { loginSuccess } from '/@/websocket/util/config'

const whiteList = ['/project', '/freeLogin', '/pilot-login', '/songList', '/404']

router.beforeEach(async (to, from, next) => {
  if (localStorage.getItem(ELocalStorageKey.Token)) {
    const flag: number = Number(localStorage.getItem(ELocalStorageKey.Flag))
    switch (flag) {
      case EUserType.Web:
        // 动态路由未注册时拉取一次（刷新业务页需要）；不能用「侧边栏是否为空」判断，无菜单权限时也会一直是 []
        if (!store.state.dynamicRoutesRegistered) {
          try {
            const accessRoutes = await store.dispatch('GenerateRoutes')
            if (Array.isArray(accessRoutes)) {
              const notFoundName = notFoundRoute.name as string
              if (router.hasRoute(notFoundName)) {
                router.removeRoute(notFoundName)
              }
              accessRoutes.forEach((route: RouteRecordRaw) => {
                router.addRoute(route) // 同名路由会被替换，不能 skip，否则菜单新增子路由后仍 404
              })
              router.addRoute(notFoundRoute)
            }
            // 刷新时在动态路由注册前会先命中通配 NotFound，to.name 为 'NotFound'。
            // 若使用 next({ ...to }) 会把 name 传给下一次导航，路由仍会按名称解析成 404。
            // 只按 path 重新匹配即可落到正确的动态路由。
            return next({
              path: to.path,
              query: to.query,
              hash: to.hash,
              replace: true,
            })
          } catch (err) {
            console.error('GenerateRoutes error:', err)
            // 动态路由生成失败时，静态路由继续放行，避免“全站404”
            if (to.name && to.name !== 'NotFound') {
              return next()
            }
            return next('/project')
          }
        }

        return next()
      case EUserType.Pilot:
        return next()
      default:
        return next()
    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      return next()
    }
    // 未知地址的 404（通配路由 name 为 NotFound）
    if (to.name === 'NotFound') {
      return next()
    } else if (to.path.startsWith('/large_screen')) {
      const urlToken = to.query.token
      // 有 token → 尝试免登录
      if (urlToken) {
        try {
          const res = await loginByToken(<loginByToken>{ token: urlToken })
          if (res.code === 0) {
            loginSuccess(res)
            // 登录成功后去掉 token 参数（防止泄露）
            return next({ path: to.path, query: {} })
          }
          return next('/project')
        } catch (err) {
          console.error('Token 登录失败', err)
          return next('/project')
        }
      } else {
        return next('/project')
      }
    } else if (to.path.startsWith('/manage_device')) {
      const urlToken = to.query.token
      // 有 token → 尝试免登录
      if (urlToken) {
        try {
          const res = await loginByToken(<loginByToken>{ token: urlToken })
          if (res.code === 0) {
            loginSuccess(res)
            // 登录成功后去掉 token 参数（防止泄露）
            return next({ path: to.path, query: { id: to.query.id, deviceSn: to.query.deviceSn } })
          }
          return next('/project')
        } catch (err) {
          console.error('Token 登录失败', err)
          return next('/project')
        }
      } else {
        return next('/project')
      }
    } else {
      return next('/project') // 否则全部重定向到登录页
    }
    // next()
  }
})
